export default "__VITE_ASSET__b566cf26__"